import React, { useState } from "react";
import { X, Mail, Phone, MessageCircle } from "lucide-react";

const HelpModal = ({ onClose }) => {
  // Search state
  const [searchTerm, setSearchTerm] = useState("");
  const [showSupport, setShowSupport] = useState(false);

  // Help topics data
  const helpTopics = [
    { title: "Your Orders", desc: "Track, cancel, or return your orders" },
    { title: "Returns & Refunds", desc: "Learn how to return items or get refunds" },
    { title: "Payments", desc: "Manage your cards, UPI, and wallet" },
    { title: "Account Settings", desc: "Change password, address, or email" },
    { title: "Prime Membership", desc: "Manage your Smoky Prime subscription" },
    { title: "Shipping & Delivery", desc: "Check estimated delivery times" },
    { title: "Rewards & Coupons", desc: "Redeem offers and loyalty rewards" },
    { title: "Customer Support", desc: "Contact our support team for help" },
    { title: "Policies", desc: "Privacy, Terms, and Returns policy" },
  ];

  // Filter topics by search term
  const filteredTopics = helpTopics.filter((topic) =>
    topic.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-2xl rounded-2xl shadow-lg p-6 relative transition-all duration-300">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-900"
        >
          <X size={24} />
        </button>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          Help & Customer Service
        </h2>

        {/* Search Bar */}
        {!showSupport && (
          <div className="mb-6">
            <input
              type="text"
              placeholder="Search help topics..."
              className="w-full border rounded-md p-2 outline-none focus:ring-2 focus:ring-amber-500"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        )}

        {/* Support Contact View */}
        {showSupport ? (
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-amber-600 mb-2">Contact Support</h3>
            <p className="text-gray-700 text-sm mb-4">
              We're here to help! Choose your preferred way to reach us:
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button className="flex items-center justify-center w-full sm:w-1/3 border rounded-lg py-3 hover:bg-amber-50 transition">
                <MessageCircle className="mr-2 text-amber-600" /> Live Chat
              </button>
              <button className="flex items-center justify-center w-full sm:w-1/3 border rounded-lg py-3 hover:bg-amber-50 transition">
                <Mail className="mr-2 text-amber-600" /> Email Us
              </button>
              <button className="flex items-center justify-center w-full sm:w-1/3 border rounded-lg py-3 hover:bg-amber-50 transition">
                <Phone className="mr-2 text-amber-600" /> Call Support
              </button>
            </div>

            <div className="text-center mt-4">
              <button
                onClick={() => setShowSupport(false)}
                className="text-amber-500 hover:underline text-sm"
              >
                ← Back to Help Topics
              </button>
            </div>
          </div>
        ) : (
          // Help Topics Grid
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {filteredTopics.map((item, idx) => (
              <div
                key={idx}
                className="p-4 border rounded-lg hover:shadow-md cursor-pointer transition"
                onClick={() =>
                  item.title === "Customer Support" && setShowSupport(true)
                }
              >
                <h3 className="font-semibold text-amber-600">{item.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{item.desc}</p>
              </div>
            ))}

            {/* Show message if no results found */}
            {filteredTopics.length === 0 && (
              <p className="col-span-full text-center text-gray-500">
                No help topics found for "{searchTerm}"
              </p>
            )}
          </div>
        )}

        {/* Footer */}
        {!showSupport && (
          <div className="mt-6 text-center text-sm text-gray-600">
            Still need help?{" "}
            <button
              onClick={() => setShowSupport(true)}
              className="text-amber-500 hover:underline"
            >
              Contact Support
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpModal;
